import React from 'react';

import { useAuth } from '../../hooks/useAuth';
import { USER_TYPES } from '../../utils/constants';
import { Banner } from './Banner';

export const PharmacyNetworkChangesBanner = () => {
  const { userType } = useAuth();

  if (userType !== USER_TYPES.PATIENT) {
    return null;
  }

  return (
    <Banner
      colour="info"
      title="Pharmacy Network Update"
      description="We've made some updates to our pharmacy network to improve access and reliability across Australia. Available pickup options may look a little different next time you order. If you have any questions, our Support team is here to help."
    />
  );
};
